import e from"./descriptors.js";import r from"./fails.js";import t from"./document-create-element.js";var o=e,a=r,i=t,n=!o&&!a(function(){return Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a!=7});export{n as default};
